import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react'
import { cn } from '@/common/utilities.ts'
import { useState } from 'react'
import { ChildrenProp } from '@/common/types_and_interfaces.ts'

type TooltipProps = {
  message: string
  className?: string
} & ChildrenProp

export default function Tooltip({
  className,
  children,
  message,
}: TooltipProps) {
  const [isHovering, setIsHovering] = useState(false)
  return (
    <Popover className="relative">
      <PopoverButton
        className="cursor-default"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        {children}
      </PopoverButton>
      <Transition show={isHovering}>
        <PopoverPanel
          transition
          anchor="right"
          className={cn(
            'z-10 bg-white border border-gray-100 rounded-md',
            className
          )}
        >
          <div className="p-2 text-sm text-gray-500 font-medium">{message}</div>
        </PopoverPanel>
      </Transition>
    </Popover>
  )
}
